import React, {useEffect, useState} from 'react'
import {toAbsoluteUrl} from '../../../../../../_metronic/helpers'
import {Link, useNavigate} from 'react-router-dom'
import {getEcontractSignLinks} from '../../../../auth/components/server/UpdateAccount'
import Swal from 'sweetalert2'
import {showToast} from '../../../../auth/components/middleware/showToast'

export const ModalReaded = ({eKYCRes, loading}: any) => {
  const [submitBtnLastStep, setSubmitBtnLastStep] = useState(false)
  const history = useNavigate()

  const showErrorModal = (title: string) => {
    return Swal.fire({
      title,
      html: `Vui lòng liên hệ NHSV theo số <b>19001055</b> để biết thêm chi tiết.`,
      allowOutsideClick: false,
      icon: 'error',
      confirmButtonText: 'Đã hiểu',
    })
  }

  const handleContractInitRetry = async (idno: string) => {
    const {error_code, error_desc} = await getEcontractSignLinks({idno})

    if (error_code === '0000') {
      showToast(error_desc, 1500, 'success')
      history('/open-account/auth/contract')
      return
    }

    if (error_code === '1005') {
      const result = await showErrorModal('Hợp đồng chưa được khởi tạo thành công')
      if (result.isConfirmed) {
        history('/auth')
      }
    }
  }

  const handleSignLink = async () => {
    try {
      const idno = eKYCRes?.ocr.object.id
      const {error_code, error_desc} = await getEcontractSignLinks({idno})

      if (error_code === '0000') {
        showToast(error_desc, 1500, 'success')
        history('/open-account/auth/contract')
        return
      }

      if (error_code === '1005') {
        const result = await Swal.fire({
          html: 'Hợp đồng chưa được khởi tạo thành công. Quý khách vui lòng nhấn Tải lại để tải hợp đồng',
          icon: 'error',
          showDenyButton: true,
          denyButtonText: `Đóng`,
          allowOutsideClick: false,
          confirmButtonText: 'Tải lại',
        })

        if (result.isConfirmed) {
          await handleContractInitRetry(idno)
        } else if (result.isDenied) {
          history('/auth')
        }
      }
    } catch (error) {
      const result = await showErrorModal('Liên hệ admin')
      if (result.isConfirmed) {
        history('/auth')
      }
    }
  }

  // useEffect(() => {
  //   handleModal(submitBtnLastStep)
  // }, [handleModal, submitBtnLastStep])

  return (
    <div className='modal fade' data-bs-backdrop='static' tabIndex={-1} id='kt_modal_1'>
      <div className='modal-dialog'>
        <div className='modal-content'>
          <div className='modal-body'>
            <div className='d-flex justify-content-center mt-4 flex-column align-items-center'>
              <div className='mx-5'>
                <img src={toAbsoluteUrl('/media/nhsv/eKYC-4-done.png')} alt='img' />
              </div>
              <h4>Đang khởi tạo hợp đồng</h4>
              <span className='text-dark text-center mt-2'>
                Hợp đồng của quý khách đang được khởi tạo. Quý khách vui lòng hoàn tất việc đăng ký
                mở tài khoản bằng cách ấn nút "Tiếp theo".
              </span>
            </div>
            <div
              className='mb-7 fv-row border p-4 rounded mt-7'
              style={{backgroundColor: '#fffbe6'}}
            >
              <p style={{display: 'list-item', marginLeft: '12px'}}>
                Tài khoản của quý khách sẽ bị hạn chế một số tính năng nếu chưa hoàn thành việc ký
                hợp đồng.
              </p>
              <p style={{display: 'list-item', marginLeft: '12px'}}>
                Quý khách có thể ký hợp đồng sau khi mở tài khoản tại
                <span className='fw-bold' style={{color: '#2c8d96'}}>
                  {' '}
                  Mở rộng → Thông tin cá nhân
                </span>
              </p>
            </div>
            <div className='text-black-50'>
              <span className='fw-bold'>Note:</span> Chữ ký tay hoặc chữ ký do Khách hàng upload tại
              bước Ký số sẽ đồng thời là Chữ ký mẫu của Khách hàng (được sử dụng để đối chiếu với
              chữ ký trên Hồ sơ khác của Khách hàng phát sinh trong tương lai). Khách hàng lưu ý ký
              hoặc updoad đúng chữ ký của mình để đảm bảo không bị gián đoạn sử dụng dịch vụ tại
              NHSV.
            </div>
          </div>
          <div className='modal-footer'>
            {/* <Link to='/auth/contract'> */}
            <button
              disabled={loading}
              onClick={handleSignLink}
              type='button'
              className='btn btn-primary'
              data-bs-dismiss='modal'
            >
              {loading ? 'Loading...' : 'Tiếp theo'}
            </button>
            {/* </Link> */}
          </div>
        </div>
      </div>
    </div>
  )
}
